import Confetti from "canvas-confetti";

window.Confetti = Confetti;
